import React from 'react';
import Grid from '@material-ui/core/Grid';
import SubscriptionModel from '../../../../models/subscription';
import LzFormFieldStatic from '../../../commons/forms/fields/static';
import { lzGetFormattedAmount } from '../../../../services/LzUtils';
import { lzGetFormattedDate } from '../../../../services/LzMoment';

class SubscriptionInfoViewComponent extends React.Component {

    render() {
        const { subscription } = this.props;

        return (
            <div className="lz-form" style={{ marginTop: 24 }}>
                <Grid container spacing={2}>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscribed Package Name" value={subscription.package_name} />
                    </Grid>
                    <Grid item sm={6} md={8}>
                        <LzFormFieldStatic fluid label="Package Summary" value={subscription.package_summary} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscription Term" value={subscription.term_name} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscription Cost" value={lzGetFormattedAmount(subscription.cost) + ' per term'} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscribed On" value={lzGetFormattedDate(subscription.created_at)} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscription Status" value={SubscriptionModel.getStatusName(subscription.status)} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscription Starts at" value={lzGetFormattedDate(subscription.started_at, '', 'n/a')} />
                    </Grid>
                    <Grid item sm={6} md={4}>
                        <LzFormFieldStatic fluid label="Subscription Expires or Cancelled at" value={lzGetFormattedDate(subscription.ended_at, '', 'n/a')} />
                    </Grid>
                </Grid>
            </div>
        );
    }

}

export default SubscriptionInfoViewComponent;
